import data from './data.js';
import network from './network.js';
import sessionTimeout from './sessionTimeout.js';

/**
 * @param {import('axios').AxiosInstance} axios
 */
export default function initializeInterceptors(axios) {
  return {
    data: data(axios),
    network: network(axios),
    sessionTimeout: sessionTimeout(axios)
  };
}
